export default __webpack_public_path__ + "static/media/reload.e95ef86a.svg";